
import { Routes } from '@angular/router';

import { LegalNoticeDetailComponent } from './legal-notice-detail.component';

export const legalNoticeRoute: Routes = [
  {
    path: 'legal-notice',
    component: LegalNoticeDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.footer.legalInfo'
    }
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal-notice/legal-notice.route.ts